<div class="progress-cont">
    <div class="progress" [style.width.%]="progress" [style.backgroundColor]="color">
    </div>
  </div>
  